'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_ROLES_REQUEST: 'FETCH_ROLES_REQUEST',
    FETCH_ROLES_SUCCEEDED: 'FETCH_ROLES_SUCCEEDED',
    FETCH_ROLES_FAILED: 'FETCH_ROLES_FAILED',
    FETCH_ROLE_REQUEST: 'FETCH_ROLE_REQUEST',
    FETCH_ROLE_SUCCEEDED: 'FETCH_ROLE_SUCCEEDED',
    FETCH_ROLE_FAILED: 'FETCH_ROLE_FAILED',
    EDIT_ROLE_REQUEST: 'EDIT_ROLE_REQUEST',
    EDIT_ROLE_SUCCEEDED: 'EDIT_ROLE_SUCCEEDED',
    EDIT_ROLE_FAILED: 'EDIT_ROLE_FAILED',
    EDIT_ROLE_CANCELED: 'EDIT_ROLE_CANCELED',
    CREATE_ROLE_REQUEST: 'CREATE_ROLE_REQUEST',
    CREATE_ROLE_SUCCEEDED: 'CREATE_ROLE_SUCCEEDED',
    CREATE_ROLE_FAILED: 'CREATE_ROLE_FAILED'
};

function fetchRolesRequest() {
    return {
        type: actionTypes.FETCH_ROLES_REQUEST
    };
}

function fetchRolesSucceeded(roles) {
    return {
        type: actionTypes.FETCH_ROLES_SUCCEEDED,
        roles: roles
    };
}

function fetchRolesFailed() {
    return {
        type: actionTypes.FETCH_ROLES_FAILED
    };
}

function fetchRoleRequest(roleId) {
    return {
        type: actionTypes.FETCH_ROLE_REQUEST,
        roleId: roleId
    };
}

function fetchRoleSucceeded(role) {
    return {
        type: actionTypes.FETCH_ROLE_SUCCEEDED,
        role: role
    };
}

function fetchRoleFailed() {
    return {
        type: actionTypes.FETCH_ROLE_FAILED
    };
}

function editRoleRequest(roleId, changes, redirect) {
    return {
        type: actionTypes.EDIT_ROLE_REQUEST,
        roleId: roleId,
        changes: changes,
        redirect: redirect
    };
}

function editRoleSucceeded() {
    return {
        type: actionTypes.EDIT_ROLE_SUCCEEDED
    };
}

function editRoleFailed() {
    return {
        type: actionTypes.EDIT_ROLE_FAILED
    };
}

function editRoleCanceled() {
    return {
        type: actionTypes.EDIT_ROLE_CANCELED
    };
}

function createRoleRequest(role, redirect) {
    return {
        type: actionTypes.CREATE_ROLE_REQUEST,
        role: role,
        redirect: redirect
    };
}

function createRoleSucceeded() {
    return {
        type: actionTypes.CREATE_ROLE_SUCCEEDED
    };
}

function createRoleFailed() {
    return {
        type: actionTypes.CREATE_ROLE_FAILED
    };
}

var actionCreators = {
    fetchRolesRequest: fetchRolesRequest,
    fetchRolesSucceeded: fetchRolesSucceeded,
    fetchRolesFailed: fetchRolesFailed,
    fetchRoleRequest: fetchRoleRequest,
    fetchRoleSucceeded: fetchRoleSucceeded,
    fetchRoleFailed: fetchRoleFailed,
    editRoleRequest: editRoleRequest,
    editRoleSucceeded: editRoleSucceeded,
    editRoleFailed: editRoleFailed,
    editRoleCanceled: editRoleCanceled,
    createRoleRequest: createRoleRequest,
    createRoleSucceeded: createRoleSucceeded,
    createRoleFailed: createRoleFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/roles.js
// module id = 221
// module chunks = 0